import { createRoute, redirect } from '@tanstack/react-router';

import { NO_PARITY } from './adminRoute';
import { noticeState } from './notice';
import { withRequestedDialog } from './requestedDialog';

import type { AnyRoute } from '@tanstack/react-router';

import type { RequestedDialog } from './requestedDialog';
import type { SingleRootParity, SingleRootStaticData } from './types';

export interface RedirectRouteOptions {
  parent: AnyRoute;
  /** The legacy Rails path spec in TanStack syntax. */
  path: string;
  railsAction: string;
  title: NonNullable<SingleRootStaticData['title']>;
  /** Where the legacy page lives in the New UI, from the legacy URL's params. */
  to: (params: Record<string, string>) => string;
  /** Says where the redirect lands and why, when the page there does not show it. */
  notice?: string;
  /** The dialog the destination opens once (`requestedDialog`). */
  dialog?: RequestedDialog;
  /** The legacy page's affordances the destination implements. */
  parity?: SingleRootParity;
}

/**
 * A legacy URL whose page the New UI folds into another one. The redirect happens before the
 * route loads and replaces the history entry; the notice rides in the destination's history
 * state and the shell shows it once that location resolves.
 */
export const redirectRoute = ({
  dialog,
  notice,
  parent,
  parity = NO_PARITY,
  path,
  railsAction,
  title,
  to
}: RedirectRouteOptions): AnyRoute => {
  const staticData: SingleRootStaticData = {
    railsAction,
    leave: 'client',
    title,
    breadcrumbs: undefined,
    parity
  };
  return createRoute({
    getParentRoute: () => parent,
    path,
    staticData,
    beforeLoad: ({ params }) => {
      const href = to(params as Record<string, string>);
      redirect({
        href: dialog ? withRequestedDialog(href, dialog) : href,
        replace: true,
        state: notice ? noticeState(notice) : undefined,
        throw: true
      });
    }
  });
};
